export const AUTHENTICATION_KEY = 'auth'
